import { render, staticRenderFns } from "./integralCoupon.vue?vue&type=template&id=78f8d802&scoped=true&"
import script from "./integralCoupon.vue?vue&type=script&lang=js&"
export * from "./integralCoupon.vue?vue&type=script&lang=js&"
import style0 from "./integralCoupon.vue?vue&type=style&index=0&id=78f8d802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f8d802",
  null
  
)

component.options.__file = "integralCoupon.vue"
export default component.exports